import { Component, OnInit } from '@angular/core';
import {SubmissionSearchObject, SubmissionSearchUserInfoObject} from '../search-object';
import {Subscription} from 'rxjs';
import {SubmissionHistoryService} from '../../../shared/services/submission-history.service';
import {KpiService} from '../../../shared/services/kpi.service';

@Component({
  selector: 'kpi',
  templateUrl: './kpi.component.html',
  styleUrls: ['./kpi.component.scss']
})
export class KpiComponent implements OnInit {

    searchCriteria: SubmissionSearchObject =  new SubmissionSearchObject();
    userInfo: SubmissionSearchUserInfoObject = new SubmissionSearchUserInfoObject();

    private        kpiSearchResult: Subscription;
    private        userInfoSubscription: Subscription;

    perYear: any;
    perMonth: any;
    perDay: any;
    perProject: any;
    perCenter: any;
    perTestType: any;

    submissionsPerYearTitle = 'Total Lab Submissions By Year';
    xSubmissionsPerYearLabel = 'Year';
    ySubmissionsPerYearLabel = 'Count';

    submissionsPerMonthTitle = 'Submissions Breakdown By Month';
    xSubmissionsPerMonthLabel = 'Month';
    ySubmissionsPerMonthLabel = 'Count';

    submissionsPerDayTitle = 'Submissions Breakdown By Day';
    xSubmissionsPerDayLabel = 'Day';
    ySubmissionsPerDayLabel = 'Count';

    submissionsPerProjectTitle = 'Submissions Breakdown By Project';
    xSubmissionsPerProjectLabel = 'Project Name';
    ySubmissionsPerProjectLabel = 'Count';

    submissionsPerCenterTitle = 'Submissions Breakdown By Center';
    xSubmissionsPerCenterLabel = 'Reporting Center';
    ySubmissionsPerCenterLabel = 'Count';


    constructor(private submissionHistoryService: SubmissionHistoryService,
                 private kpiService: KpiService
    ) {
    }

    ngOnInit() {
        this.userInfoSubscription = this.submissionHistoryService.currentUserInfo.subscribe(message => {this.userInfo = message});

        this.kpiService.triggerKpiSearch(this.searchCriteria, null, null);
        this.kpiService.currentKpiSearchCriteria.subscribe(message => {
            this.searchCriteria = message;
        });
        this.kpiService.currentPerYearChart.subscribe(message => {
            this.perYear = message;
        });
        this.kpiService.currentAveragePerMonthChart.subscribe(message => {
            this.perMonth = message;
        });
        this.kpiService.currentAveragePerDayChart.subscribe(message => {
            this.perDay = message;
        });
        this.kpiService.currentPerProjectChart.subscribe(message => {
            this.perProject = message;
        });
        this.kpiService.currentPerCenterChart.subscribe(message => {
            this.perCenter = message;
        });
        this.kpiService.currentPerTestTypeChart.subscribe(message => {
            this.perTestType = message;
        });
    }
}
